const MainVisual = () => (
  <section
    className="relative flex flex-col items-center justify-center overflow-hidden pt-28 pb-16 px-5"
    style={{ background: '#fff' }}
  >
    {/* 背景の淡い装飾 */}
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        background:
          'radial-gradient(ellipse at 30% 20%, rgba(167,139,250,0.1) 0%, transparent 60%), radial-gradient(ellipse at 70% 80%, rgba(167,139,250,0.07) 0%, transparent 60%)',
      }}
    />

    {/* メインコンテンツ */}
    <div className="relative z-10 text-center flex flex-col items-center max-w-lg mx-auto w-full">
      {/* ラベル */}
      <div
        className="mb-5 inline-flex items-center gap-2 px-4 py-1.5 rounded-full"
        style={{
          background: 'rgba(167,139,250,0.12)',
          border: '1px solid rgba(167,139,250,0.25)',
        }}
      >
        <span
          className="text-[10px] tracking-[0.35em] font-medium"
          style={{ color: '#7c3aed', fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          DIAGNOSIS PORTAL
        </span>
      </div>

      {/* メインタイトル */}
      <h1
        className="text-[#1a1a2e] font-bold leading-tight mb-4"
        style={{
          fontFamily: "'M PLUS Rounded 1c', sans-serif",
          fontSize: 'clamp(1.8rem, 7vw, 2.6rem)',
          lineHeight: 1.25,
        }}
      >
        あなたを
        <span style={{ color: '#a78bfa' }}>診断</span>
        しよう
      </h1>

      {/* サブタイトル */}
      <p
        className="text-[#6b7280] leading-relaxed"
        style={{
          fontFamily: "'M PLUS Rounded 1c', sans-serif",
          fontSize: '0.875rem',
        }}
      >
        気になる診断を選んでスタート。<br />
        あなたの知らない自分が見えてくる。
      </p>
    </div>
  </section>
);

export default MainVisual;
